export type AspectRatio = keyof typeof ASPECT_RATIO;
export const ASPECT_RATIO = {
    '16:9': 16 / 9,
} as const;
